import { useFormikContext } from "formik";
import { Divider, Grid } from "@mui/material";
import { paymentTypeEnum, productCategoryEnum } from "../../../../utils/enum";
import { CheckboxInput } from "../../../../components";

const StaticIp = () => {
  const formik: any = useFormikContext();
  return (
    <>
      {formik.values?.categoryId === productCategoryEnum.connectService &&
        (Number(formik.values?.paymentType) === paymentTypeEnum.new ||
          Number(formik.values?.paymentType) === paymentTypeEnum.churn) && (
          <>
            <Divider />
            <CheckboxInput name="staticIp" label={"Statik IP"} />
            <Divider />
          </>
        )}
    </>
  );
};

export default StaticIp;
